<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'
import { useRemoveInventObjectFile } from './../model/model.ts'

const props = defineProps({
  objectId: {
    type: Number,
    required: true,
  },
  file: {
    type: String,
    required: true,
  },
  removedHandler: {
    type: Function,
    required: true,
  },
})

const { remove } = useRemoveInventObjectFile()

/**
 * Функция обработки удаления элемента
 */
const clickHandler = () => {
  remove(
    {
      id: props.objectId,
      file: props.file,
    },
    props.removedHandler,
  )
}
</script>

<template>
  <VBtn color="error" icon density="compact" @click="clickHandler">
    <VIcons type="delete" />
  </VBtn>
</template>
